// extracted by mini-css-extract-plugin
export default {"clickable":"UserListTable_clickable__9+w1y"};